import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { isValidURL } from 'modules/core/lib/url'

interface FormInitialValues {
  system_and_defense_custom_url?: string | null
}

export class PrivacyPolicyForm extends Form {
  constructor(values: FormInitialValues) {
    super(values, {
      system_and_defense_custom_url: 'string',
    })

    makeObservable(this, {
      isValid: computed,
    })
  }

  get isValid(): boolean {
    const value = this.get('system_and_defense_custom_url').value

    return (value !== '' && isValidURL(value)) || value === ''
  }
}
